import { chakra, Box, Flex, Text, Image, Button } from '@chakra-ui/react';
import React, { useContext } from 'react';
import LogoDashboard from '../../images/petalas-deovita.svg';
import NotificationIcon from '../../images/notification_icon_1.svg';
import '../AreaLivre/PerfilEmpresa/css/main.css';
import { AccountContext } from '../AccountContext';
import { useNavigate } from 'react-router-dom';

function UserHeaderLivre() {
  const { user, webviewParams } = useContext(AccountContext);

  const navigate = useNavigate();

  const { loggedIn, id_contrato, titular } = user;

  const backgroundColor =
    titular === true && id_contrato === 0
      ? '#5AB2AE'
      : titular === false && id_contrato === 0
      ? '#5AB2AE'
      : titular === true && id_contrato > 0
      ? '#5AB2AE'
      : '#5AB2AE';

  let message = webviewParams?.subscriber || 'Assine agora!';
  if (user.situacao_contrato === 'P') message = 'Contrato em análise';
  return (
    <>
      <chakra.header w="full" py={0} shadow="md" backgroundColor={backgroundColor} minHeight="136px" borderBottomRadius="30px">
        <Flex alignItems="center" justifyContent="space-between" mx="auto" ml={{ sm: '40px', base: '10px' }}>
          <Flex direction="column">
            <chakra.h2 fontSize="1em" fontWeight="bold" mt="43px" color="white">
              Este é seu app de saúde
              <br />
            </chakra.h2>
            <Button
  fontSize="12px"
  minH="20px"
  h="auto"
  px={3}
  py={1}
  maxW="100%"
  whiteSpace="normal"
  wordBreak="break-word"
  textAlign="center"
  lineHeight="1.2"
  color={backgroundColor}
  borderRadius={20}
  onClick={() => {
    if (message === 'Assine agora!') {
      navigate('/cadastro/plano');
    }
  }}
>
  {message}
</Button>

          </Flex>
          <Box display={{ base: 'inline-flex' }}>
            <Image
              w="70px"
              h="55px"
              me={{ sm: '30px', base: '10px' }}
              position="absolute"
              right="0.02rem"
              top="43px"
              src={LogoDashboard}
              alt="teste"
            />
          </Box>
        </Flex>

        <Text
          position="absolute"
          fontSize="xl"
          fontWeight="bold"
          pt="1.1em"
          textColor="white"
          textShadow="2px 3px 5px #808080"
          textAlign="center"
          width="90%"
          zIndex="1"
        ></Text>
        <Flex justifyContent="flex-end">
          {loggedIn && (
            <Image
              w="20px"
              h="20px"
              mt={4}
              position="absolute"
              mr={7}
              src={NotificationIcon}
              alt="notification"
              onClick={() => {
                alert('show notification');
              }}
            />
          )}
        </Flex>
      </chakra.header>
    </>
  );
}

export default UserHeaderLivre;
